$(() => {
    let url = window.location.href;
    $('.nav-menu__item-link').each(function () {
        let link = $(this).prop('href');
        if (link === url) {
            $(this).addClass('active');
        }
    });
})


// WEBPACK FOOTER //
// ./markup/components/nav/nav.js